import React from 'react';

// Единый тултип для всех графиков страницы статистики.
const ChartTooltip = ({ active, payload, label, formatter }) => {
  if (!active || !payload || payload.length === 0) return null;

  return (
    <div className="stats-tooltip">
      <div className="stats-tooltip-title">{label}</div>
      {payload.map((item) => (
        <div className="stats-tooltip-row" key={item.dataKey ?? item.name}>
          <span className="stats-dot" style={{ background: item.color || item.payload?.color }} />
          <span className="stats-tooltip-name">{item.name}</span>
          <span className="stats-tooltip-value">
            {formatter ? formatter(item.value, item) : item.value?.toLocaleString('ru-RU')}
          </span>
        </div>
      ))}
    </div>
  );
};

export default ChartTooltip;
